module.exports = __webpack_public_path__ + "img/dianjifenbutu.0a63f962.svg";